export class LeadGenerationStep
{
    // starting step (package)
    static readonly ORDER_TYPE: string = "ORDER_TYPE";
    // second step
    static readonly SOLAR_BATTERY: string = "SOLAR_BATTERY";
    static readonly SOLAR: string = "SOLAR";
    static readonly BATTERY: string = "BATTERY";
    // third step
    static readonly CREATE_APPOINTMENT: string = "CREATE_APPOINTMENT";
    static readonly ORDER: string = "ORDER";
    // final step
    static readonly ORDER_CONFIRMATION: string = "ORDER_CONFIRMATION";
    // final step if new construction
    static readonly CONFIRMATION_NEW_CONSTRUCTION: string = "CONFIRMATION_NEW_CONSTRUCTION";
}
